<!-- Translated: yes -->
<template>
  <div class="center component">
    <h1>{{ $t('general.payment-code-confirmation') }}</h1>
    <!-- <p>Om din bokning ska betalas skickar vi dig en betal-länk via sms, godkänn betalningen så snart som möjligt. Har du inte fått en länk inom ett dygn, kontakta oss på tel <a href="tel:+46 54-13 26 00">054-13 26 00</a>.</p> -->
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>{{ $t('general.bookingnumber') }}:</p>
    <p><b style="font-size:1.5em;">{{ number }}</b></p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import API from '@/classes/API';

export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      number: null,
    };
  },
  async mounted() {
    const { order_number } = await API.get(`/payments/order-creating-status?code=${this.$route.query.code}`); // eslint-disable-line
    this.number = order_number; // eslint-disable-line

    this.clearCart();
  },
  methods: {
    ...mapMutations([
      'clearCart',
    ]),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.component
  padding-top 75px
</style>



// WEBPACK FOOTER //
// PayedWithCodeConfirmationPage.vue?5907dcce